// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"36009bc7","159":"f2ff2154","169":"0f73e974","481":"d68550bb","634":"49952185","635":"48d13324","899":"c3c86f95"}[chunkId] + ".chunk.js";
};